import { gzipSync, strToU8 } from "fflate";
import { PingBodyOverflowError } from "./ping_body_overflow_error.js";
export default class PingRequest {
    constructor(identifier, headers, payload, maxBodySize) {
        this.identifier = identifier;
        this.headers = headers;
        this.payload = payload;
        this.maxBodySize = maxBodySize;
    }
    asCompressedPayload() {
        if (this.headers["Content-Encoding"] == "gzip") {
            return this;
        }
        const encodedBody = strToU8(this.payload);
        let finalBody;
        const headers = this.headers;
        try {
            finalBody = gzipSync(encodedBody);
            headers["Content-Encoding"] = "gzip";
            headers["Content-Length"] = finalBody.length.toString();
        }
        catch (_a) {
            return this;
        }
        if (finalBody.length > this.maxBodySize) {
            throw new PingBodyOverflowError(`Body for ping ${this.identifier} exceeds ${this.maxBodySize} bytes. Discarding.`);
        }
        return new PingRequest(this.identifier, headers, finalBody, this.maxBodySize);
    }
}
